const gateway = '/dapi/api-gateway/h5/scrm-qwagg-service';
import { post } from '@/api/index';
export default {
  // 一维标签list
  getTagList(data, headers = {}) {
    return post(gateway + '/api/v1/cus/tagBase/get_list_by_param', data);
  },
};
